import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from './FormError';
import InputField from './InputField';

let VerifyCodeForm = ({
  handleSubmit,
  error,
  successMsg,
  isSentVerificationCode,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field component={InputField} name="code" label="Code*" />
        {error && <FormError error={error} />}
        {successMsg && <p className="text-success">{successMsg}</p>}
        <button className="btn btn-primary" disabled={!isSentVerificationCode}>
          Verify
        </button>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.code) {
    errors.code = 'Required';
  }

  return errors;
};

VerifyCodeForm = reduxForm({
  form: 'verifyVerificationCode',
  validate,
  enableReinitialize: true,
})(VerifyCodeForm);

export default VerifyCodeForm;
